import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, ViewController, NavParams, Navbar, App } from 'ionic-angular';
// import { TranslateService } from '@ngx-translate/core';
import { LoginPage } from '../login/login';

/**
 * Generated class for the CompletePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-complete',
	templateUrl: 'complete.html',
})
export class CompletePage {
    @ViewChild(Navbar) navBar: Navbar;

    loginId: string;
    api_key: string;
    email: string;
    version: string;

	target: string;
	value: string;
	coin_unit: string;
	unit: string;
	
	texts: any = [];
    language : string;

	constructor(
		public navCtrl: NavController,
		public viewCtrl: ViewController,
		public navParams: NavParams,
		public app: App
	) {
		this.target = navParams.get("target");
        this.value = navParams.get("value");
        
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "complete");
        this.language = localStorage.getItem("language");
        this.email = localStorage.getItem("email");
        this.version = localStorage.getItem("version");
        this.coin_unit = localStorage.getItem("coin_unit");
        this.unit = localStorage.getItem("unit");
        
        // this.navBar.backButtonClick = (e:UIEvent)=>{
        //     // todo something
        //     this.navCtrl.parent.select(1);
        // }

        this._get_texts();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).complete;
	}

 	_Close(){
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/complete/complete.ts